import { render } from "./choosecontractforlaundry.vue?vue&type=template&id=43bafe1d"
import script from "./choosecontractforlaundry.vue?vue&type=script&lang=js"
export * from "./choosecontractforlaundry.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__